import CrudPage from "../components/CrudPage";

const PRIORITY = { dusuk: "Düşük", orta: "Orta", yuksek: "Yüksek" };
const PRIORITY_STYLE = { dusuk: "bg-gray-100 text-gray-600", orta: "bg-amber-50 text-amber-600", yuksek: "bg-red-50 text-red-600" };
const STATUS = { bekliyor: "Bekliyor", tamamlandi: "Tamamlandı", iptal: "İptal Edildi" };
const STATUS_STYLE = { bekliyor: "bg-blue-50 text-blue-600", tamamlandi: "bg-emerald-50 text-emerald-600", iptal: "bg-gray-100 text-gray-500" };

export default function Agenda() {
  return (
    <CrudPage
      title="Ajanda"
      subtitle="Saatlik görev planınızı yönetin"
      module="agenda"
      endpoint="/tasks"
      addLabel="Yeni Görev"
      defaultValues={{ priority: "orta", status: "bekliyor", color: "#D4AF37", reminder: false }}
      filters={[
        { name: "status", label: "Durum", options: Object.entries(STATUS).map(([v, l]) => ({ value: v, label: l })) },
        { name: "priority", label: "Öncelik", options: Object.entries(PRIORITY).map(([v, l]) => ({ value: v, label: l })) },
      ]}
      columns={[
        {
          key: "title", label: "Görev",
          render: (r) => (
            <span className="flex items-center gap-2 font-medium">
              <span className="h-3 w-3 shrink-0" style={{ backgroundColor: r.color || "#D4AF37" }} />
              {r.title}
            </span>
          ),
        },
        { key: "date", label: "Tarih" },
        { key: "time", label: "Saat" },
        { key: "priority", label: "Öncelik", render: (r) => <span className={`px-2 py-1 text-xs font-semibold ${PRIORITY_STYLE[r.priority] || ""}`}>{PRIORITY[r.priority] || "-"}</span> },
        { key: "status", label: "Durum", render: (r) => <span className={`px-2 py-1 text-xs font-semibold ${STATUS_STYLE[r.status] || ""}`}>{STATUS[r.status] || "-"}</span> },
        { key: "reminder", label: "Hatırlatma", render: (r) => (r.reminder ? "Açık" : "Kapalı") },
      ]}
      fields={[
        { name: "title", label: "Görev Başlığı", required: true, colSpan: 2 },
        { name: "date", label: "Tarih", type: "date", required: true },
        { name: "time", label: "Saat", type: "time", required: true },
        { name: "priority", label: "Öncelik", type: "select", options: Object.entries(PRIORITY).map(([v, l]) => ({ value: v, label: l })) },
        { name: "status", label: "Durum", type: "select", options: Object.entries(STATUS).map(([v, l]) => ({ value: v, label: l })) },
        { name: "color", label: "Renk Etiketi", type: "color" },
        { name: "reminder", label: "Hatırlatma", type: "checkbox" },
        { name: "note", label: "Açıklama", type: "textarea" },
      ]}
    />
  );
}
